import { faWindowMaximize } from "@fortawesome/free-regular-svg-icons/faWindowMaximize";
export let iconApp = faWindowMaximize;
export function overwriteApp(icon) {
    iconApp = icon;
}
export default iconApp;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYXBwLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL2FwcC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFDQSxPQUFPLEVBQUUsZ0JBQWdCLEVBQUUsTUFBTSxzREFBc0QsQ0FBQztBQUV4RixNQUFNLENBQUMsSUFBSSxPQUFPLEdBQUcsZ0JBQWdCLENBQUM7QUFFdEMsTUFBTSxVQUFVLFlBQVksQ0FBQyxJQUFvQjtJQUMvQyxPQUFPLEdBQUcsSUFBSSxDQUFDO0FBQ2pCLENBQUM7QUFFRCxlQUFlLE9BQU8sQ0FBQyJ9